<template >
  <coming-soon></coming-soon>
</template >

<script >
import ComingSoon from './ComingSoon'
export default {
  name: 'SupplierDashboard',
  components: {ComingSoon}
}
</script >

<style scoped >

</style >


// WEBPACK FOOTER //
// src/components/SupplierDashboard.vue